var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6069 16.8692L15.1761 14.4842C14.5153 13.3834 14.1661 12.1225 14.1661 10.8392V8.75C14.1661 6.1125 12.4061 3.88168 9.99941 3.1625V1.66668C9.99941 0.7475 9.25191 0 8.33273 0C7.41355 0 6.66605 0.7475 6.66605 1.66668V3.1625C4.25941 3.88168 2.49941 6.1125 2.49941 8.75V10.8392C2.49941 12.1225 2.15023 13.3825 1.49023 14.4834L0.0594074 16.8684C-0.0180926 16.9975 -0.0197722 17.1575 0.0544075 17.2884C0.128587 17.4192 0.266087 17.5 0.416087 17.5H16.2494C16.3994 17.5 16.5377 17.4192 16.6119 17.2892C16.6861 17.1592 16.6836 16.9975 16.6069 16.8692Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70801 18.3333C6.17801 19.3149 7.17301 19.9999 8.33215 19.9999C9.49129 19.9999 10.4863 19.3149 10.9563 18.3333H5.70801Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.8ea2d52a.svg";
export { ForwardRef as ReactComponent };